export default __webpack_public_path__ + "static/media/products-details-tab-01.6348569a.jpg";